export const scrollbarStyles = {
  none: {
    scrollbarWidth: "none" as const, // Firefox
    msOverflowStyle: "none" as const, // IE / old Edge

    "&::-webkit-scrollbar": {
      display: "none", // Chrome, Safari, Edge
    },
  },
};
